<template>
  <div style="height: 0;width: 0;overflow: hidden;">
    <img :src="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/share_default_logo@2x.png')" />
  </div>

  <div class="store-div" v-if="useIsMobile().value">
    <!-- 头部 -->
    <KHeader
      @click="actvFn"
      :shareBtnShow="true"
      :storeInfo="storeInfo"
    />
    <!-- 店铺信息 -->
    <div class="store-info-div">
      <div class="left">
        <img @error="imgErrorFn($event)" :src="$cvWebpFn ? $cvWebpFn(storeInfo.storeIcon): storeInfo.storeIcon" />
      </div>
      <div class="content">
        <h1 class="name">{{storeInfo.name}}</h1>

        <div class="store-info">
          <div class="followers">
            Total {{ storeInfo.products }} products | {{ storeInfo.follows > 1000 ? `${storeInfo.follows / 1000}K` : storeInfo.follows }} followers
          </div>
        </div>
        <div class="store-info">
          <!-- authType: 1 官方店铺，2 品牌授权店 -->
          <img v-if="storeInfo.authType === 1" class="store-tag" :src="$cvWebpFn(OFFICIAL_STORE_BADGE_URL)" alt="Brand Official" />
          <img v-else-if="storeInfo.authType === 2" class="store-tag" :src="$cvWebpFn(AUTHORIZED_STORE_BADGE_URL)" alt="Brand Authorized" />
          <img v-if="storeInfo.tags?.includes('store_preferred')" class="store-tag" :src="$cvWebpFn(PREFERRED_STORE_BADGE_URL)" alt="Preferred Store" />

          <div class="score-mark">
            Score:{{ storeCommentStat.score }}({{ storeCommentStat.commentNum }} Ratings)
          </div>
        </div>
      </div>
      <div
        class="right" 
        :class="{'checked' : storeInfo.isFollow}"
        @click="storeInfo.isFollow ? deleteFollowFn() : postFollowFn()"
      >
        <span v-if="storeInfo.isFollow">Following</span>
        <span v-else>Follow</span>
      </div>
    </div>
    
    <div class="tabs">
      <div class="tab" v-show="active === 'home'">
        <div v-for="(config, idx) in storeCms" :key="idx">
          <AdvList v-if="config.adv_list" :store-id="storeId" :data="config.adv_list" />

          <CutImage v-if="config.cut_image" :store-id="storeId" :data="config.cut_image" />

          <TitleBar v-if="config.title" :store-id="storeId" :data="config.title" />

          <GoodsList
            v-if="config.goods && config.goods.elementParams.length > 0 && Object.keys(cmsValidProducts).length > 0"
            :store-id="storeId"
            :data="config.goods"
            :valid-products="cmsValidProducts"
          />
        </div>

        <p class="you-my-also-like"><span>You May Also Like</span></p>
        <KProductList :product-list="recommendProductList" />
      </div>

      <div class="tab" v-show="active === 'product'">
        <div class="product-div">
          <van-list
            :loading="productLoading"
            :finished="productFinished"
            finished-text="no more"
            loading-text="loading..."
            :immediate-check="false"
            :offset="300"
            @load="getStoreAllProductsFn('more')"
          >
            <KProductList :product-list="storeProductList" />
          </van-list>
        </div>
      </div>
      <div class="tab" v-show="active === 'category'">
        <van-cell
          v-for="(item, idx) in categoryList" 
          :key="idx" 
          :title="item.name" 
          is-link 
          :value="`(${item.products} products)`"
          @click="clsClickFn(item)"
        />
      </div>

      <div class="switch-btns">
        <div class="switch-btn" :select="active === 'home' ? '1' : '0'" @click="tabChangeFn('home')">
          <van-icon name="shop-o" />
          <p class="btn-name">Home</p>
        </div>
        <div class="switch-btn" :select="active === 'product' ? '1' : '0'" @click="tabChangeFn('product')">
          <van-icon name="bag-o" />
          <p class="btn-name">Products</p>
        </div>
        <div class="switch-btn" :select="active === 'category' ? '1' : '0'" @click="tabChangeFn('category')">
          <van-icon name="apps-o" />
          <p class="btn-name">Category</p>
        </div>
        <div class="switch-btn" :select="active === 'chat' ? '1' : '0'" @click="handleToChatClick">
          <van-icon name="chat-o" />
          <p class="btn-name">Contact Seller</p>
        </div>
      </div>
    </div>

    <div v-show="voucherList.length > 0" class="voucher-popup-open-btn" @click="handleShowPopupClick">
      <img :src="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/voucher-icon-167.png', { w: 120 })" alt="">
    </div>

    <LazyVoucherCouponPopup
      v-model:visible="couponPopupShow"
      :voucher-list="[voucherList]"
      title-text="Vouchers"
      show-type="store"
      receive-scene="SHOP_PAGE"
      @update:voucher="handleVoucherUpdate"
    />
  </div>

  <PCStore
    v-else
    v-model:active="active"
    :store="storeInfo"
    :store-comment-stat="storeCommentStat"
    :voucher-list="voucherList"
    :categoryList="categoryList"
    :storeListings="pcStoreProductList"
    :pagination="paginationPC"
    :storeRecommendListings="recommendProductList"
    @search:click="searchFn"
    @page:change="handlePCPageChange"
    @ctg:click="clsClickFn"
    @follow:click="storeInfo.isFollow ? deleteFollowFn() : postFollowFn()"
    @chat:click="handleToChatClick"
  />
</template>

<script setup lang="ts">
import PCStore from '@/pages-pc/Store.vue'
import { ref } from 'vue'
import { getVoucherGensByStoreId } from '@/api/models/userInfo'
import {
  getStoreInfo,
  postFollow,
  deleteFollow,
  getRecommendedProduct,
  getStoreAllProducts,
  getStoreCategories,
  storeCMSConfig,
  getStoreInfoByAlias
} from '@/api/models/store'
// import './_cms/html2canvas.min.js'
import { getCommentStatistics } from '@/api/models/reviews'
import AdvList from './_cms/AdvList.vue'
import CutImage from './_cms/CutImage.vue'
import TitleBar from './_cms/TitleBar.vue'
import GoodsList from './_cms/GoodsList.vue'
import {
  buildStoreAllProductListingSource,
  buildStoreCategoryNavigationSource,
  buildStoreHomeListingSource,
  buildStoreSearchListingSource,
  resolveStoreHomeFirstPage,
  resolveStoreHomeSourceValue
} from '@/plugins/utils'

definePageMeta({ layout: 'wap' })
type TabType = 'home' | 'product' | 'category' | 'chat'
const OFFICIAL_STORE_BADGE_URL = 'https://image.kilimall.com/c/h5/ic_official_store.png'
const AUTHORIZED_STORE_BADGE_URL = 'https://image.kilimall.com/c/h5/ic_authorized_store.png'
const PREFERRED_STORE_BADGE_URL = 'https://image.kilimall.com/c/h5/ic_preferred_storex.png'
const { $cvWebpFn, $getCountry, $setFacebookShareMates, $asyncLoadJs, $formatStringToURL } = useNuxtApp()
const router = useRouter()
const route = useRoute()
const active = ref<TabType>(useIsMobile().value ? 'home' : 'product')

/** 获取店铺基础信息 */
const storeInfo: any = ref({})
const voucherList: any =ref([])
let storeId: any = route.params.id
const countryCode = $getCountry().code
const isMobile = useIsMobile().value
const storeCommentStat = reactive<{ score: string, commentNum: string }>({ score: '5.0', commentNum: '' })
const getStoreInfoFn = async () => {
  let _sid = storeId
  let fn = getStoreInfoByAlias
  // 如果 ID 为纯数字，那么优先通过ID获取
  if(/^\d+$/.test(storeId)) {
    fn = getStoreInfo

    _sid = Number(storeId)
  }
  
  let res
  try {
    res = await fn(_sid, true)
  } catch(e) {
    const backFn = /^\d+$/.test(storeId) ? getStoreInfoByAlias : getStoreInfo

    res = await backFn(_sid, true)
  }

  if(res && res.code === 0) {
    if(!res.data.store.starRating) res.data.store.starRating = 5
    storeInfo.value = res.data.store

    storeId = storeInfo.value.id
    const { commentNum, starRating} = storeInfo.value
    const reviewTotal = commentNum > 1000 ? (commentNum / 1000).toFixed(1) + 'K' : `${commentNum}`
    storeCommentStat.commentNum = reviewTotal
    storeCommentStat.score = starRating.toFixed(1)
  }
}


const storeCms = ref<IStore.ICmsConfig[]>([])
const cmsValidProducts = ref<IAnyObject>({})

const initStoreCms = async() => {
  try {
    const storeCMSResult = await storeCMSConfig(storeId, countryCode)
    storeCms.value = storeCMSResult?.datas || []
  } catch(e) {
    console.error(e)
  }
}
// 获取店铺优惠券
const getVoucherGensByStoreIdFn = async () => {
  const res = await getVoucherGensByStoreId(storeId)
  console.log(555, res)
  if(res && res.code === 0) {
    voucherList.value = (res.data.gens || []).map((item: any) => {
      return {
        ownerType: 2,
        voucherType: 1,
        ...item
      }
    })
  }
}
const initStoreCmsGoods = async() => {
  const goodsIds: number[] = []

  storeCms.value.filter(c => c.goods && c.goods.item.length > 0).forEach((item: IStore.ICmsConfig) => {
    if(item.goods) {
      goodsIds.push(...item.goods.elementParams)
    }
  })
  if (!goodsIds || goodsIds.length <= 0) {
    return
  }
  const listingsResult = await getStoreAllProducts(
    storeId,
    { skip: 0, limit: goodsIds.length, includedListingIds: goodsIds },
    false,
    true
  )
  const listings = listingsResult?.data?.result || []

  listings.forEach((c: any) => { cmsValidProducts.value[c.listingId] = c })
}

/** 获取店铺推荐商品  */
const recommendProductList = ref([])
const getRecommendedProductFn = async () => {
  const res = await getRecommendedProduct(storeId, false)
  if(res && res.code === 0) { 
    const storeFirstPage = resolveStoreHomeFirstPage(route)
    recommendProductList.value = (res.data.listings || []).map((c: any) => {
      c.source = buildStoreHomeListingSource(
        resolveStoreHomeSourceValue('recommend', c),
        storeFirstPage,
        route
      )
      return c
    })
  }
}

/** 获取店铺分类  */
const categoryList = ref<any>([])
const getStoreCategoriesFn = async (isServe: boolean = true) => {
  const res = await getStoreCategories(storeId, isServe) // !useIsMobile().value)
  if(res && res.code === 0) {
    categoryList.value = res.data.categories || []
  }
}

/** 获取店铺所有商品  */
const storeProductList = ref<any>([])
const pcStoreProductList = ref<any>([])
const productFinished = ref(false)
const productLoading = ref(false)
const storeProductParams = ref({ skip: 0, limit: useIsMobile().value ? 10 : 20, keywords: '' })
const paginationPC = reactive({ maxPage: 0, currentPage: 1 })
const getStoreAllProductsFn = async (type?:string) => {
  if(!isMobile) {
    storeProductParams.value.skip = (paginationPC.currentPage - 1) * storeProductParams.value.limit
  } else {
    if(productLoading.value || productFinished.value) {
      return
    }
  }

  process.client && (productLoading.value = true)

  // const isServer = useIsMobile().value
  try {
    const res: any = await getStoreAllProducts(
      storeId,
      storeProductParams.value,
      type !== 'more',
      !isMobile
    )

    if(res && res.code === 0) {
      const storeFirstPage = resolveStoreHomeFirstPage(route)
      const keywords = storeProductParams.value.keywords || ''
      const list: Array<any> = (res.data.result || []).map((c: any) => {
        // 店铺内搜索：sourceType 为 storeSearch；全部商品列表仍为 storeAllProduct
        c.source = keywords
          ? buildStoreSearchListingSource(keywords, route)
          : buildStoreAllProductListingSource('', storeFirstPage, route)
        return c
      })

      storeProductList.value.push(...list)
      pcStoreProductList.value = list
      
      productFinished.value = list.length < storeProductParams.value.limit
    
      if(!isMobile) {
        const { skip, limit } = storeProductParams.value
        paginationPC.currentPage = Math.ceil(skip / limit) + 1
        paginationPC.maxPage = Math.ceil(res.data.total / limit) || 1
      }

      storeProductParams.value.skip += storeProductParams.value.limit
    }
  } catch(e) {
    console.error(e)
  } finally {
    productLoading.value = false
  }
}

try {
  await getStoreInfoFn()
  const fns = [getRecommendedProductFn]

  if(useIsMobile().value) {
    fns.push(initStoreCms)
  } else{
    fns.push(getStoreCategoriesFn, getStoreAllProductsFn)
  }
  await Promise.all(fns.map(fn => fn()))
  if(useIsMobile().value) {
    await initStoreCmsGoods()
  }
  // 单独接口获取店铺优惠券
  await getVoucherGensByStoreIdFn()
} catch(e) {
  console.error(e)
}

const { name, storeIcon } = storeInfo.value
const currentHost = useCurrentHost()

$setFacebookShareMates({
  title: name,
  image: storeIcon,
  url: `${currentHost}/store/${storeId}`,
  description: `🌟 Online shopping on Kilimall! Check out ${name} for amazing deals and products! 🛒💖`,
  type: 'website'
})
useHead({
  link: [
    {
      rel: 'canonical',
      href: `${currentHost}/store/${storeInfo.value.storeAlias || storeId}`
    }
  ]
})
/** ---------------------------------------------------------- */

const handleVoucherUpdate = (item: any, index: number) => {
  const voucher = voucherList.value[index]
  voucher.isEarned = true

  voucherList.value.splice(index, 1, voucher)
}

/** 跳转搜索（透传店铺入口 first_page：cart / productDetail 等） */
const actvFn = () => {
  const query: Record<string, string> = {
    storeId: String(storeInfo.value.id),
    from: 'store'
  }
  const firstPage = resolveStoreHomeFirstPage(route)
  if (firstPage) {
    query.first_page = firstPage
  }
  router.push({ path: '/search', query })
}

const couponPopupShow = ref<boolean>(false)
const handleShowPopupClick = () => {
  couponPopupShow.value = true
}

/** 关注店铺 */
const postFollowFn = async () => {
  const res = await postFollow(storeId)
  if(res && res.code === 0) {
    storeInfo.value.isFollow = true
    storeInfo.value.follows = res.data.follows
  }
}

/** 取消店铺关注 */
const deleteFollowFn = async () => {
  const res = await deleteFollow(storeId)
  if(res && res.code === 0) {
    storeInfo.value.isFollow = false
    storeInfo.value.follows = res.data.follows
  }
}

/** 店铺分类点击 */
const clsClickFn = (item: any) => {
  const { id, name } = item
  const source = buildStoreCategoryNavigationSource(name, route)

  // name 可能含 `/` 等字符，需 formatStringToURL，与全站类目跳转一致
  router.push({
    path: `/category/${$formatStringToURL(String(name || ''))}`,
    query: {
      storeId: String(storeId),
      storeCategoryIds: String(id),
      source
    }
  })
}

/** 切换tab */
const tabChangeFn = (name: TabType) => {
  active.value = name
  if(name === 'product' && storeProductList.value.length <= 0) {
    getStoreAllProductsFn()
  } else if(name === 'category' && categoryList.value.length <= 0) {
    getStoreCategoriesFn(false)
  }
}

/** 默认店铺头像 */
const imgErrorFn = (event: any) => {
  event.currentTarget.setAttribute(
    "src",
    $cvWebpFn("https://image.kilimall.com/lite/new_wap/default/store_default.png")
  )
}

// PC搜索店铺内商品
const searchFn = async(key: string) => {
  storeProductParams.value.keywords = key
  paginationPC.currentPage = 1
  await getStoreAllProductsFn()
}

// pc
const handlePCPageChange = async(e: number) => {
  paginationPC.currentPage = e

  await getStoreAllProductsFn()
}

const handleToChatClick = () => {
  const { id, name, storeIcon } = storeInfo.value
  const query = {
    storeId: id,
    storeName: name,
    storeIcon: storeIcon,
    chat_first_page: 'store'
  }

  if(!useUserInfo().value?.accessToken) {
    const targetUrl = router.resolve({ path: '/message/store-chat', query }).href
    
    return router.push(`/login?redirect=${decodeURIComponent(targetUrl)}`)
  } else {
    if(useIsMobile().value) { 
      router.push({ path: '/message/store-chat', query })
    } else {
      const { id: storeId, name, storeIcon } = storeInfo.value
      const productMsg: Pick<Msg.IMsgProduct, 'storeId' | 'storeName' | 'storeIcon'> = {
        // goodsId: id,
        // goodsName: title,
        // goodsPic: imageUrl || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
        // goodsUnit: !currentSelectedSKU.value?.inventory ? 'Out of stock' : $currencySymbol(),
        // goodsPrice: minListPrice || '',
        storeId: storeId,
        storeName: name,
        storeIcon
      }

      usePCOpenRoomInfo().value = { source: '', msgType: 3, store: productMsg, chatFirstPage: 'store' }
      usePCLiveChatPopupShow().value = true
    }
  }
}
</script>
<style lang='scss' scoped>
.header-div {
  z-index: 200;
}
.voucher-popup-open-btn{
  position: fixed;
  bottom: 15%;
  right: 10px;
  img{
    width: 120px;
    height: 120px;
    object-fit: contain;
  }
}
.you-my-also-like{
  text-align: center;
  padding-bottom: 10px;
  margin: 20px 0 15px 0;
  font-weight: 600;
  font-size: 28px;
  position: relative;
  &::after{
    content: "";
    position: absolute;
    bottom: 0;
    left: calc(100% / 2 - 50px);
    width: 100px;
    height: 3px;
    border-radius: 4px;
    background-color: #333;
  }
}
.tabs{
  padding-bottom: 110px;
}
.switch-btns{
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 101;
  height: 100px;
  align-items: center;
  overflow: hidden;
  .switch-btn{
    flex: .25;
    margin-top: 10px;
    text-align: center;
    transition: all .2s;
    font-size: 24px;
    .btn-name{
      color: #666;
    }
    i{ font-size: 54px;}
  }
  .switch-btn[select="1"] {
    color: var(--default_color);
    .btn-name{ color: var(--default_color); }
  }
}
.store-div {
  width: 100%;
  padding-top: 90px; // var(--van-nav-bar-height);
  box-sizing: border-box;
  min-height: 100vh;
  background-color: #f3f5f9;
  .recommend-product-div {
    margin: 10px;
  }
  .voucher-div {
    width: 100%;
    overflow-x: auto;
    padding: 10px;
    // margin: 10px 0;
    display: flex;
    .voucher-item {
      width: 400px;
      max-width: 400px;
      display: flex;
      border-radius: 8px;
      overflow: hidden;
      background: white;
      flex: 1 0 auto;
      margin-right: 20px;
      background:linear-gradient(90deg, #ffe5cc 0%, #ffcb9a 100%);
      .left {
        width: 100px;
        flex: 1;
        padding: 20px;
        .price {
          font-size: 30px;
          margin: 10px 0;
          font-weight: 600;
        }
        .desc {
          margin-top: 15px;
          font-size: 22px;
          margin-bottom: 10px;
        }
      }
      .right {
        width: 120px;
        font-size: 24px;
        @include center();
        background-color: var(--font_color_04);
        color: white;
      }
      .now {
        background-color: var(--default_color);
      }
    }
  }
  .store-info-div {
    width: 100%;
    display: flex;
    background-color: white;
    box-sizing: border-box;
    margin-top: -4px;
    padding: 50px 30px 30px 30px;
    .left {
      img {
        width: 88px;
        height: 88px;
        object-fit: contain;
      }
    }
    .content {
      width: 100ox;
      flex: 1;
      margin-left: 30px;
      .name {
        color: #150000;
        font-size: 28px;
        font-weight: 700;
      }
      .store-info{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .mark-base{
          border-radius: 4px;
          font-size: 20px;
          padding: 0 8px;
          display: inline-block;
        }
        .store-tag {
          display: block;
          width: auto;
          height: 32px;
          margin-top: 10px;
          margin-right: 10px;
        }
        .score-mark{
          @extend .mark-base;
          border: 1px solid #E9DDD0;
          color: #9a550d;
          margin-top: 10px;
          height: 32px;
          line-height: 32px;
          color: #915414;
        }
        .followers{
          color: #999;
          font-size: 22px;
        }
      }
    }
    .right {
      padding: 0 20px;
      width: 140px;
      color: #666666;
      text-align: center;
      line-height: 60px;
      border-radius: 42px;
      font-size: 22px;
      height: 60px;
      background: linear-gradient(90deg, #f87622 0%, #e02020 100%);
      color: #fff;
    }
    .checked {
      background: #999999;
    }
  }
  .store-data{
    background-color: #fff;
    padding: 0 30px;
    padding-bottom: 10px;
    color: #666;
    span{
      display: inline-block;
    }
    .score{
      border-right: 1px solid #666;
      padding-right: 20px;
    }
    .total{
      padding-left: 20px;
    }
  }
}
</style>
